// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-p_gk","advertDetailServiceList__header":"c-p_gl","advertDetailServiceList__list":"c-p_gm"};